// import {
//   Info as Icon
// } from 'components/icons';
import React from 'react';
import { Icon } from 'semantic-ui-react';

function TheIcon (props) {
  return <Icon name="hdd outline" {...props}  />;
}

export const meta = {
  id: 'Drives',
  title: 'Drives',
  category: 'Media & Files',
  exposes: [
    {
      title: 'Drive',
      action: { module: 'Drives', props: { /* */ } },
    },
    // {
    //   title: 'New Drive',
    //   action: { module: 'DrivesDetails', props: { context: 'add' } },
    // },
    { title: "My Files", action: { module: 'Drives', props: { } }},
    {
      title: "Org Files",
      action: {
        module: 'Drives', props: { context: 'org' }
      }
    },
    {
      title: "Product Files",
      action: {
        module: 'Drives', props: { context: 'product' }
      }
    },
    {
      title: "Tenant Files",
      action: {
        module: 'Drives',
        props: { context: 'tenant' }
      }
    },
    {
      title: "Public Files",
      action: {
        module: 'Drives',
        props: { context: 'public' }
      }
    },
  ],
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `The drive for the storage services`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
